import { render, staticRenderFns } from "./InitPassword.vue?vue&type=template&id=c433f52c&scoped=true"
import script from "./InitPassword.vue?vue&type=script&lang=js"
export * from "./InitPassword.vue?vue&type=script&lang=js"
import style0 from "./InitPassword.vue?vue&type=style&index=0&id=c433f52c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c433f52c",
  null
  
)

export default component.exports